const translations = {
    actionsLabel: 'License actions',
    addLicense: 'Add License',
    delete: 'Delete',
    deleteConfirmCancel: 'Keep License',
    deleteConfirmLabel: 'Delete License',
    deleteConfirmMessage:
        'This pesticide license will be permanently removed from your organization.',
    deleteConfirmTitle: 'Delete this license?',
    deleteError: 'Pesticide license could not be deleted.',
    deleteSuccess: 'Pesticide license deleted.',
    edit: 'Edit',
    emptyDescription: 'Add a business pesticide license to see it listed here.',
    emptyHeading: 'No pesticide licenses yet',
    expirationDate: 'Expiration Date',
    expired: 'Expired',
    issuedDate: 'Issued Date',
    licenseNumber: 'Pesticide License Number',
    loadError: 'Pesticide licenses could not be loaded.',
    loadMore: 'Load more',
    state: 'State',
    tableLabel: 'Business pesticide licenses',
    title: 'Business Pesticide Licenses'
};

export default translations;
